var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 40.0001C31.046 40.0001 40.0003 31.0458 40.0003 20.0001C40.0003 8.95438 31.046 7.62939e-05 20.0003 7.62939e-05C8.95461 7.62939e-05 0.000305176 8.95438 0.000305176 20.0001C0.000305176 31.0458 8.95461 40.0001 20.0003 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1305 20H40C40 18.1948 39.7594 16.4462 39.311 14.7826H19.1305V20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1305 9.56529H37.0646C35.8403 7.56748 34.275 5.80162 32.4498 4.34787H19.1305V9.56529Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C24.7072 40.0001 29.0335 38.3732 32.45 35.6523H7.55048C10.967 38.3732 15.2933 40.0001 20.0002 40.0001V40.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93551 30.4348H37.0646C38.0475 28.8311 38.8096 27.0778 39.311 25.2174H0.689026C1.19035 27.0778 1.95262 28.8311 2.93551 30.4348V30.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 20.0001C20.0003 8.95445 20.0003 7.65226 20.0003 7.62939e-05C8.95468 7.62939e-05 0.000305176 8.95445 0.000305176 20.0001H20.0003Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2997 17.1196C10.5683 17.1196 8.35406 14.9053 8.35406 12.1739C8.35406 9.4426 10.5684 7.2283 13.2997 7.2283C14.1513 7.2283 14.9527 7.44369 15.6523 7.82275C14.5548 6.74955 13.0538 6.08705 11.3975 6.08705C8.03586 6.08705 5.31055 8.81229 5.31055 12.174C5.31055 15.5357 8.03586 18.261 11.3975 18.261C13.0538 18.261 14.5548 17.5985 15.6523 16.5253C14.9527 16.9042 14.1514 17.1196 13.2997 17.1196V17.1196Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6932 8.69565L15.5713 10.5317L17.5542 10.0736L16.6662 11.9048L18.2609 13.1694L16.2754 13.617L16.281 15.6522L14.6932 14.3789L13.1054 15.6522L13.1109 13.617L11.1254 13.1694L12.7201 11.9048L11.8321 10.0736L13.8151 10.5317L14.6932 8.69565Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.a592d4411c776846eddca33bb1258211.svg";
export { ForwardRef as ReactComponent };